// extracted by mini-css-extract-plugin
export default {"wrapper":"AdminDashboard_wrapper__HRKlD","container":"AdminDashboard_container__p+j9t"};